// extracted by mini-css-extract-plugin
export default {"imageWrapper":"TextureImage_imageWrapper__oHXg6","spinner":"TextureImage_spinner__KYCH7","spin":"TextureImage_spin__w+mpB","visuallyHidden":"TextureImage_visuallyHidden__lRhgM"};